import Text from "../../../../styleguide/Text";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import usePermissions from "../../../../router/usePermissions";
import userRoles from "../../../../constants/userRoles";

function TableCustomHeader() {
  const { routeParams } = useRoutesHelper();
  const { nrauto } = routeParams as { nrauto: string };
  const { isAuthorized } = usePermissions();

  const CAR_FEATURE_CREATE_PERMISSION = isAuthorized(
    userRoles.CAR_FEATURE_CREATE,
  );

  return (
    <div className="flex items-center justify-between gap-4">
      <Text
        variant="h3"
        component="h3"
        className="mb-4 font-semibold text-slate-900"
        gutterBottom>
        Echipamente auto {nrauto || ""} care asigura conformitatea transportului{" "}
      </Text>
      <ActionMenu
        items={[
          {
            id: "add-equipment",
            label: "Adauga echipament nou",
            icon: "ADD",
            tooltip: "Deschide formularul pentru un echipament nou al masinii.",
            hidden: !CAR_FEATURE_CREATE_PERMISSION,
            navigate: `create?nrauto=${nrauto}`,
          },
        ]}
        title={nrauto}
        ariaLabel={`Actiuni pentru echipamentele masinii ${nrauto}`}
      />
    </div>
  );
}

export default TableCustomHeader;
